module.exports = __webpack_public_path__ + "img/parking_wait_time_blk.5ebe1af3.svg";